import { ArrowUpRight, Check } from 'lucide-react';
import { Watermark } from './Watermark';

export const ServiceCard = ({ service, onQuote }) => {
    return (
        <article
            data-testid={service.testid}
            className="group relative overflow-hidden rounded-2xl bg-white border border-border hover:border-primary/20 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(17,47,34,0.35)] flex flex-col"
        >
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
                <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    style={service.imageStyle}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-50 group-hover:opacity-30 transition-opacity" />
                <span className="absolute top-4 left-4 text-[10px] tracking-[0.22em] uppercase font-outfit bg-white/85 backdrop-blur px-3 py-1 rounded-full text-foreground">
                    {service.kicker}
                </span>
            </div>

            <div className="p-7 flex flex-col flex-1">
                <h3 className="font-outfit text-2xl tracking-tight">{service.title}</h3>
                <p className="text-muted-foreground text-[15px] leading-relaxed mt-3">{service.summary}</p>

                <ul className="mt-5 space-y-2.5">
                    {service.bullets.map((b) => (
                        <li key={b} className="flex items-start gap-2.5 text-sm text-foreground/80">
                            <Check className="w-3.5 h-3.5 mt-1 text-accent flex-shrink-0" strokeWidth={2.4} />
                            <span>{b}</span>
                        </li>
                    ))}
                </ul>

                <button
                    onClick={() => onQuote?.(service.title)}
                    data-testid={`${service.testid}-quote`}
                    className="mt-auto pt-7 flex items-center justify-between text-sm font-outfit text-foreground hover:text-primary transition-colors group/btn"
                >
                    <span>Request a quote</span>
                    <span className="grid place-items-center w-9 h-9 rounded-full bg-muted group-hover/btn:bg-primary group-hover/btn:text-primary-foreground transition-all">
                        <ArrowUpRight className="w-4 h-4" strokeWidth={1.6} />
                    </span>
                </button>
            </div>
        </article>
    );
};
